// extracted by mini-css-extract-plugin
export default {"sectionTitle":"FD1ISj","card":"eRgXH0","getItButton":"C3Wskw","premiumBadge":"vfRdwn","domainTitle":"obEoX1","pricing":"euNxAS"};